
import "./planning.scss";

export class PlanningController {
    filter: string;

    static $inject = [];

    constructor() {

    }
}
